/**
 * 网站配置文件
 */

const config = {
  appName: '千米云',
  // httpRequestUrl: 'http://localhost/api/v2/'
  httpRequestUrl: 'https://qmy.1000kx.com/api/v2/'
}

export default config
